import { forwardRef } from "react";

import { tw } from "~/utils";

export const TableWrapper = forwardRef<
  HTMLTableElement,
  React.HTMLAttributes<HTMLTableElement>
>(({ className, ...props }, ref) => (
  <div
    className={tw(
      "bg-surface-container-high relative w-full overflow-hidden rounded-xl",
      className,
    )}
  >
    <table ref={ref} className="w-full" {...props} />
  </div>
));
TableWrapper.displayName = "TableWrapper";
